import React from 'react';
import { IconProps } from './types';

export const FullscreenExitIcon: React.FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4 14h6v6M20 10h-6V4" />
  </svg>
);
